import React, { FC, memo } from 'react';
import { Typography } from '@mui/material';

interface CategoryTitleProps {
  children: React.ReactNode;
}

const CategoryTitle: FC<CategoryTitleProps> = ({ children }) => {
  return (
    <Typography
      sx={{
        fontFamily: 'Montserrat',
        fontSize: { xs: '20px', sm: '30px' },
        lineHeight: { xs: '24px', sm: '30px' },
        fontWeight: '700',
      }}
      variant="h2"
    >
      {children}
    </Typography>
  );
};

export default memo(CategoryTitle);
